import {
  initialState,
  Actions,
  State,
  EDIT_INSPECTION,
  EDIT_INSPECTION_SUCCESS,
  EDIT_INSPECTION_ERROR,
  RESET_EDIT_INSPECTION,
} from '../../types/inspection/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_INSPECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_INSPECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_INSPECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_INSPECTION:
      return initialState
    default:
      return state
  }
}

export default reducers
